import { useLocation } from "react-router-dom";
import { CHECKOUT_FUNNEL_PREFIXES, matchesPrefix, normalizeNavPath } from "../DesktopHeader/useDesktopNavVariant";

/**
 * Which responsive header a page gets. Mirrors `useDesktopNavVariant`, but the
 * mobile design splits further than desktop's full/lite pair.
 */

/** Listing / search surfaces — these get the inline search bar. */
export var LISTING_PREFIXES = ["/filters", "/deal", "/years", "/autos", "/car-countries", "/home/new-cars"];
export var CAR_DETAILS_PREFIXES = ["/car", "/cardetail"];
export var getMobileHeaderVariant = function getMobileHeaderVariant(pathname) {
  var path = normalizeNavPath(pathname);
  if (path === "/") return "home";
  // Funnel is checked before the rest so a checkout step never picks up nav.
  if (matchesPrefix(path, CHECKOUT_FUNNEL_PREFIXES)) return "funnel";
  if (matchesPrefix(path, CAR_DETAILS_PREFIXES)) return "car-details";
  if (matchesPrefix(path, LISTING_PREFIXES)) return "listing";
  return "landing";
};
var useMobileHeaderVariant = function useMobileHeaderVariant(override) {
  var _useLocation = useLocation(),
    pathname = _useLocation.pathname;
  return override !== null && override !== void 0 ? override : getMobileHeaderVariant(pathname);
};
export default useMobileHeaderVariant;